import { Selection, TextSelection } from '@atlaskit/editor-prosemirror/state';

export const normalizeRemixSelection = (selection: Selection): Selection => {
	const { $from, $to } = selection;
	if (
		!(selection instanceof TextSelection) ||
		selection.empty ||
		$from.sameParent($to) ||
		!$from.parent.isTextblock ||
		!$to.parent.isTextblock
	) {
		return selection;
	}

	let from = selection.from;
	let to = selection.to;
	if ($from.parent.content.size > 0 && $from.parentOffset === $from.parent.content.size) {
		let depth = $from.depth;
		while (depth > 1 && $from.indexAfter(depth - 1) === $from.node(depth - 1).childCount) {
			depth--;
		}
		const next = Selection.findFrom($from.doc.resolve($from.after(depth)), 1);
		if (next instanceof TextSelection) {
			from = next.from;
		}
	}
	if ($to.parent.content.size > 0 && $to.parentOffset === 0) {
		let depth = $to.depth;
		while (depth > 1 && $to.index(depth - 1) === 0) {
			depth--;
		}
		const previous = Selection.findFrom($to.doc.resolve($to.before(depth)), -1);
		if (previous instanceof TextSelection) {
			to = previous.to;
		}
	}
	if (
		from >= to ||
		from < selection.from ||
		to > selection.to ||
		(from === selection.from && to === selection.to)
	) {
		return selection;
	}
	return TextSelection.create(
		$from.doc,
		selection.anchor <= selection.head ? from : to,
		selection.anchor <= selection.head ? to : from,
	);
};
